// @flow

import React from "react";

import { ChatroomTitle as StyledChatroomTitle } from "./styles";
import Name from "src/containers/chatroom/Name/Title";

type Props = {
  id: number,
  handleClose: Function,
};

const ChatroomTitle = ({ id, handleClose }: Props) => (
  <StyledChatroomTitle>
    <Name id={id} handleClose={handleClose} />
  </StyledChatroomTitle>
);

export default ChatroomTitle;
